<template>
  <div>
    <section class="overlay" v-if="errored">
      <p class="overlay-text">申し訳ありませんが、<br />現時点ではこの情報を取得できません。<br />しばらくしてからもう一度お試しください</p>
    </section>

    <section v-else>
      <div class="overlay" v-if="loading">
        <p class="overlay-text loading-text">Loading...</p>
        <div class="loading-spacer">
          <vue-loading type="spiningDubbles" color="#FFF" :size="{ width: '100px', height: '100px' }"></vue-loading>
        </div>
      </div>
      <Header />
      <div class="home-body">
        <div class="user-information">
          <UserInformation @handle-loading="isLoading"/>
        </div>

        <div class="meal-record">
          <img class="frame" src="@/assets/home/アセット 33@2x.png" />
          <div class="today-img">
            <img src="@/assets/home/アセット 29@2x.png" />
          </div>
          <p class="today-date">{{ todayDate }}の食事記録</p>
          <div class="achievement-contents">
            <div class="crown-img staple-food-crown">
              <img src="@/assets/home/アセット 27@2x.png" v-if="stapleFoodCrown" />
            </div>
            <div class="crown-img side-dish-crown">
              <img src="@/assets/home/アセット 27@2x.png" v-if="sideDishCrown" />
            </div>
            <div class="crown-img water-crown">
              <img src="@/assets/home/アセット 27@2x.png" v-if="waterCrown" />
            </div>
          </div>
          <div class="alert-contents">
            <div class="alert-img staple-food-alert">
              <img src="@/assets/home/アセット 26@2x.png" v-if="stapleFoodAlert" />
            </div>
            <div class="alert-img side-dish-alert">
              <img src="@/assets/home/アセット 26@2x.png" v-if="sideDishAlert" />
            </div>
            <div class="alert-img water-alert">
              <img src="@/assets/home/アセット 26@2x.png" v-if="waterAlert" />
            </div>
          </div>
          <div class="meal-result-content">
            <div class="daily-meal-result">
              <div class="facial-expression-mark" @click="mealHistory">
                <img src="@/assets/home/アセット 23@2x.png" v-if="stapleFoodCrown" />
                <img src="@/assets/home/アセット 30@2x.png" v-if="!stapleFoodCrown" />
              </div>
              <div class="foods-graph-doughnut" @click="mealHistory">
                <p class="side-foods-score" v-bind:style="{ color: sideDishChartColor }">{{ foodsIngestedTodayScore }}</p>
                <p class="side-foods-score-text">食品群</p>
                <FoodsGraphDoughnut v-if="showFoodsGraphDoughnut" :chart-data="foodsDatacollection" :options="foodsOptions" />
              </div>
              <div class="water-graph-doughnut" @click="waterHistory">
                <p class="water-amount-score" v-bind:style="{ color: waterChartColor }">{{ foodsIngestedTodayWater }}</p>
                <p class="water-amount-score-text">ml</p>
                <WaterGraphDoughnut v-if="showWaterGraphDoughnut" :chart-data="waterDatacollection" :options="waterOptions" />
              </div>
            </div>
          </div>
        </div>

        <router-link to="/recordMeals">
          <div class="record-meals">
            <img src="@/assets/home/アセット 100@2x.png/" width="1600" height="378" loding="lazy" />
          </div>
        </router-link>

        <div class="cooperation">
          <div class="lashic-log">
            <img src="@/assets/home/アセット 34@2x.png" />
          </div>
          <img class="frame" src="@/assets/home/アセット 28@2x.png" />
          <img class="mark" src="@/assets/home/アセット 21@2x.png" />
          <div @click="openModal">
          <img class="link-button" src="@/assets/home/アセット 22@2x.png" />
          </div>
        </div>
      </div>
      <Footer />
      <Tutorial v-if="isTutorial" />
      <NotIngestedAlert v-if="showNotIngestedAlert" :notIngestedFoods="notIngestedFoods" @handle-hide-dialog="closeNotIngestedAlert"/>
      <ShowContent v-if="showContent" @handle-hide-content="closeModal" />
    </section>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import UserInformation from "@/components/UserInformation";
import Tutorial from "@/components/Tutorial";
import WaterGraphDoughnut from "@/js/WaterGraphDoughnut";
import FoodsGraphDoughnut from "@/js/FoodsGraphDoughnut";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const UserRepository = RepositoryFactory.get("user");
const FoodsRepository = RepositoryFactory.get("foods");
import moment from "moment";
import { VueLoading } from "vue-loading-template";
import NotIngestedAlert from "@/components/NotIngestedAlert";
import ShowContent from "@/components/ShowContent";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
    UserInformation,
    Tutorial,
    WaterGraphDoughnut,
    FoodsGraphDoughnut,
    VueLoading,
    NotIngestedAlert,
    ShowContent,
  },
  beforeDestroy() {
    document.body.className = "";
  },
  data() {
    return {
      number: 2,
      prevRoute: null,
      todayDate: moment().format("YYYY/MM/DD"),
      hearingsLatest: {},
      foodsIngestedToday: [],
      notIngestedFoods: [],
      showNotIngestedAlert: false,
      loading: true,
      errored: false,
      stapleFoodCrown: false,
      sideDishCrown: false,
      waterCrown: false,
      stapleFoodAlert: false,
      sideDishAlert: false,
      waterAlert: false,
      foodsIngestedTodayScore: 0,
      foodsIngestedTodayWater: 0,
      sideDishChartColor: "#000000",
      waterChartColor: "#000000",
      isTutorial: false,
      showContent: false,
      foodsDatacollection: null,
      foodsOptions: null,
      waterDatacollection: null,
      waterOptions: null,
      showFoodsGraphDoughnut: false,
      showWaterGraphDoughnut: false
    };
  },
  created() {
    // アクセストークンが有効期限きれかどうか判定する
    this.RefreshTokenUpdate()
  },
  async mounted() {
    document.body.className = "back-color";
    if (this.$store.state.isTutorial) this.isTutorial = true;

    // 毎日の食事内容取得api
    const foodsEndpoint = "ingested/today";

    await FoodsRepository.get(foodsEndpoint, this.$store.state.axiosHeaders)
      .then(response => (this.foodsIngestedToday = response.data))
      .catch((error) => {
        console.log(error);
        this.errored = true;
      });
    this.$store.commit("FETCH_ADD_FOODS_INGESTED_TODAY", this.foodsIngestedToday);
    if (Object.keys(this.foodsIngestedToday).length != 0) {
      this.foodsCheckAlert()
    } else {
      this.checkEarlierThisWeek()
    }
    this.foodsGraphDoughnutData();
    this.waterGraphDoughnutData();
    this.loading = false
  },
  methods: {
    openModal() {
      this.showContent = true;
    },
    closeModal() {
      this.showContent = false;
    },
    async RefreshTokenUpdate(){
      this.$store.state.axiosHeaders.access_token_expires_in = 1614566933; //有効期限切れトークン　検証時にコメントアウト外す
      // users.access_token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJsYXNoaWMiLCJleHAiOjE2NDA4NzY0MDAsInVzZXJfaWQiOiI3Nzc3In0.vzDNjvjXiM8f41xSU48-zI7VYEPXPbOpVlENvuHaWgg"
      let access_token_expires_in = new Date(this.$store.state.axiosHeaders.access_token_expires_in * 1000);
      let now = new Date();

      if (now > access_token_expires_in) {
        const UserEndpoint = "token/refresh";
        const body = {
          refresh_token: this.$store.state.axiosHeaders.refresh_token,
        };
        const config = {
          withCredentials: true,
        };
        await UserRepository.put(UserEndpoint, body, {config})
        .then(response => (this.res = response.data))
        .catch((error) => console.log(error))
        .finally(() => {
          const headers = {
            Authorization: "Bearer " + this.res.access_token,
            "Ocp-Apim-Subscription-Key": process.env.SUBSCRIPTION_KEY,
            access_token_expires_in: this.res.access_token_expires_in,
            refresh_token: this.res.refresh_token
            }
            this.$store.commit("FETCH_ADD_AXIOS_HEADERS", headers);
        })
      }
    },
    
    // 本日の食事履歴でアラート又はクラウンを表示するか判定する
    foodsCheckAlert() {
      const stapleFoodCheck = 1
      const waterCheck = 3
      if (this.foodsIngestedToday.results[stapleFoodCheck]) {
        this.stapleFoodCrown = true;
        this.stapleFoodAlert = false;
      } else {
        this.stapleFoodCrown = false;
        this.stapleFoodAlert = true;
      }
      if (this.foodsIngestedToday.score >= 7) {
        this.sideDishCrown = true;
        this.sideDishChartColor = "#0062FF";
      } else if (this.foodsIngestedToday.score <= 3) {
        this.sideDishAlert = true;
        this.sideDishChartColor = "#9057FF";
      } else {
        this.sideDishChartColor = "#FF851C";
      }
      if (this.foodsIngestedToday.results[waterCheck]) {
        this.waterCrown = true;
        this.waterAlert = false;
      } else {
        this.waterCrown = false;
        this.waterAlert = true;
      }
      if (this.foodsIngestedToday.water >= 1000) {
        this.waterChartColor = "#0062FF";
      } else {
        this.waterChartColor = "#8BB8FF";
      }

    this.foodsIngestedTodayScore = this.foodsIngestedToday.score;
    this.foodsIngestedTodayWater = this.foodsIngestedToday.water;
    },

   //副食のドーナツグラフデータ処理
    foodsGraphDoughnutData() {
      this.foodsDatacollection = {
        datasets: [
          {
            data: [this.foodsIngestedTodayScore,(10 - this.foodsIngestedTodayScore)],
            backgroundColor: [this.sideDishChartColor,'gainsboro'],
            borderColor: 'transparent',
            borderWidth: '50px'
          }
        ],
      },
      this.foodsOptions = {
        // 自動サイズ変更をしない
        responsive: true,
        // グラフの太さ（中央部分を何％切り取るか）
        cutoutPercentage: 80,
        //ツールチップの非表示
        tooltips: {
          enabled: false, //ここにfalseを指定
        },
      }
      this.showFoodsGraphDoughnut = true
    },

    //水分のドーナツグラフデータ処理
    waterGraphDoughnutData() {
      this.waterDatacollection = {
         datasets: [
          {
            data: [this.foodsIngestedTodayWater,(1500 - this.foodsIngestedTodayWater)],
            backgroundColor: [this.waterChartColor,'gainsboro'],
            borderColor: 'transparent',
            borderWidth: '50px'
          }
        ],
      },
      this.waterOptions = {
        // 自動サイズ変更をしない
        responsive: true,
        // グラフの太さ（中央部分を何％切り取るか）
        cutoutPercentage: 80,
        //ツールチップの非表示
        tooltips: {
          enabled: false, //ここにfalseを指定
        },
      }
      this.showWaterGraphDoughnut = true
    },

    // 今日が週初めかどうか判定する
    checkEarlierThisWeek() {
      const today = moment().format("YYYY-MM-DD")
      const thisWeekStart = moment().startOf("isoWeek").format("YYYY-MM-DD");
      if (today === thisWeekStart) this.foodsInsufficientApi()
    },

    // 週初めだった場合、先週１週間の食事履歴を取得して１週間一度も摂取していない食品があればアラートを表示する。
    async foodsInsufficientApi() {
      const lastWeekStart = moment().add("isoWeek", -1).startOf("isoWeek").format("YYYY-MM-DD");
      const lastWeekEnd = moment().add("isoWeek", -1).endOf("isoWeek").format("YYYY-MM-DD");
      const foodsEndpoint = "ingested/insufficient?from=" + lastWeekStart + "&to=" + lastWeekEnd;

      await FoodsRepository.getFromTo(foodsEndpoint, this.$store.state.axiosHeaders)
      .then(response => (this.notIngestedFoods = response.data))
      .catch(error => {
        console.log(error)
        this.errored = true
      }).finally(() => {
        if (Object.keys(this.notIngestedFoods).length != 0) this.showNotIngestedAlert = true
      })
    },

    closeNotIngestedAlert() {
      this.showNotIngestedAlert = false
    },
    mealHistory() {
      this.$router.push({name: 'History', params: {propsSelected: true}});
    },
    waterHistory() {
      this.$router.push({name: 'History', params: {propsSelected: false}});
    },
    openModal() {
      this.showContent = true
    },
    isLoading(Boolean) {
      if (Boolean) this.loading = true
      if (!Boolean) this.loading = false
    }
  },
};
</script>

<style scoped>
@import "../assets/css/home.css";
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue